import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-sb-kwijtscheldingen',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-kwijtscheldingen.component.html',
  styleUrl: './tekst-kwijtscheldingen.component.scss',
})
export class TekstKwijtscheldingenComponent {}
